export class Municipio {
  idmunicipio: string;
  idestado: string;
  municipio: string;
  alta: string;
}
